import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import techToMed from "../../../assets/images/techtomedix-logo.png";
import api from "../../../utils/Api";
import moment from "moment";
import style from "./PaymentHistory.module.css";
import { fetchHistoryList } from "../../../redux";
import { fetchTransaction } from "../../../redux";
import ReactToPrint from "react-to-print";
import { goBack } from "react-router-redux";
import history from "../../../utils/history";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

function capitalizePaymentType(cell) {
  const typeCapitalized = cell.charAt(0).toUpperCase() + cell.slice(1);
  return `${typeCapitalized}`;
}

export class PaymentHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isDataFetched: false,
      payment_id: "",
      paymentsList: [],
      isScheduledPayment: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      emailError:false,
      patientEmail:""
    };
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'Payments History - TechToMedix';
    if(this.props.location && this.props.location.params && this.props.location.params.isScheduledPayment){
        this.setState({
          isScheduledPayment: this.props.location.params.isScheduledPayment,
          sortBy: this.props.location.params.sort_by,
        },
        async () => {
          await this.props.fetchHistoryList(
            this.state.searchKey,
            this.state.sortBy,
            this.state.page,
            this.state.isScheduledPayment
          );
          if (
            this.props.historyListData &&
            this.props.historyListData.historyList &&
            this.props.historyListData.historyList.payments
          ) {
            this.setState({
              paymentsList: this.props.historyListData.historyList.payments,
            });
          }
        }
      );
    } else {
      await this.props.fetchHistoryList(
        this.state.searchKey,
        this.state.sortBy,
        this.state.page
      );

      if (
        this.props.historyListData &&
        this.props.historyListData.historyList &&
        this.props.historyListData.historyList.payments
      ) {
        this.setState({
          paymentsList: this.props.historyListData.historyList.payments,
        });
      }
    }
    setTimeout(() => {
      if (this.props.historyListData.historyList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  };

  callPaymentHistoryList = async () => {
    this.setState({
      paymentsList: [],
    });
    await this.props.fetchHistoryList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.isScheduledPayment
    );
    if (!this.props.historyListData.loading) {
      this.setState({
        paymentsList: this.props.historyListData.historyList.payments,
      });
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
      }, 1000);
    }
  };

  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="View Payment" onClick={() => this.toggle(row)}>
          <i className="fa fa-eye relatedpartylist-edit-icon"></i>
        </Link>
      </div>
    );
  }

  toggle = (val) => {
    this.setState(
      (prevState) => ({
        payment_id: val.payment_id,
        isModalOpen: !prevState.isModalOpen,
        emailError:""
      }),
      () => {
        if(this.state.isModalOpen === true){
          this.props.fetchTransaction(this.state.payment_id);
        }
      }
    );
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState(
      {
        sortName,
        sortOrder,
        sortBy,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callPaymentHistoryList();
      }
    );
    // this.props.fetchHistoryList(this.state.searchKey, sortBy, 1);
  };

  onSearchChange = (event) => {
    this.setState(
      {
        searchKey: event.target.value,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callPaymentHistoryList();
      }
    );
    // this.props.fetchHistoryList(searchText, this.state.sortBy, 1);
  };

  onPageChange = (page, sizePerPage) => {
    this.setState(
      {
        page,
        isDataFetched: false,
      },
      () => {
        this.callPaymentHistoryList();
      }
    );
    //this.props.fetchHistoryList(this.state.searchKey, this.state.sortBy, page);
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} className="loader-image" />
        </div>
      );
    }
  }

  //Share via email
  shareViaEmail = async () => {
    
    if(this.state.patientEmail==""){
        this.setState({emailError:"Patient email is mandatory"})
        return;
    }

    if(this.state.emailError!=""){
       return
    }

    this.setState({
      isLoading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    const payload = {
      payment_id: this.state.payment_id,
      email:this.state.patientEmail
    };

    try {
      const response = await api.post("payment/detail/shareViaEmail", payload, {
        headers: headers,
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Email sent successfully!",
        });

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in share via email payment", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in email sent",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  // API calls for download invoice details
  DownloadAttachment = async (attachment_id, file_name) => {
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    try {
      const response = await api.get("attachment/" + attachment_id, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file_name);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download file", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in download file",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  goBack = () => {
    history.goBack();
  }

  handleInputRef = (e) => {
    const { name, value } = e.target;
    this.setState({
        [name]: value
    },()=>{
          this.validateEmail(value)
    });
  }

  validateEmail = (email) => {
    const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const result = pattern.test(email);
    if (result === true) {
        this.setState({
            emailError: false
        })
    } else {
      
        this.setState({
            emailError: true
        })
    }
  };

  render() {
    const historyList = this.props.historyListData.historyList;
    const paymentDetails = this.props.transactionData.transactionDetails;
    const paymentProof = paymentDetails.paymentProof;
    const practice_logo = paymentDetails && paymentDetails.practice_logo;

    // console.log("Payment history list - ", historyList);
    // console.log("Payment history transaction details - ", paymentDetails);
    return (
      <div className={style.paymentHistoryMainWarapper}>
       {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
        <div className="row">
          <div className="col-lg-7">
            <h3>Payment History</h3>
          </div>
          <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
        </div>
        <div className="row">
        <div className="col-lg-12 intro-text">
            <p>
            A record of all the transactions (Make and Receive Payments) made on the system are recorded here. 
            The View action icon displays a pop-up with a summary of the transaction.
            </p>
          </div>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.paymentsList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.historyListData.historyList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn
            dataField="transaction_id"
            isKey
            dataSort={true}
            width="20%"
          >
            Transaction Id
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="invoice_number"
            dataSort={true}
            width="20%"
          >
            Invoice Number
          </TableHeaderColumn>
          <TableHeaderColumn dataField="user_name" dataSort={true} width="20%">
            Sender/Receiver
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="payment_type"
            dataSort={true}
            width="10%"
            dataFormat={capitalizePaymentType}
          >
            Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="payment_source"
            dataSort={true}
            width="20%"
          >
            Payment Source
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="created_at"
            dataSort={true}
            width="20%"
            dataFormat={dateFormatter}
          >
            Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="payment_status"
            dataSort={true}
            width="20%"
          >
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="10%"
            dataAlign="center"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>

        {/* Modal popup for payment history details  */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className="payment-history-modal"
          centered
        >
          <ModalHeader
            toggle={this.toggle}
            className={style.paymentModalHeader}
          >
            Payment -{" "}
            {paymentDetails.payment && paymentDetails.payment.transaction_id}
          </ModalHeader>
          <ModalBody className={style.paymentHistoryModal}>
            <div ref={(el) => (this.componentRef = el)}>
            <div className="row d-print-block d-none">
              {/* <div className="col-12 mb-4 text-center print-logo">
                <img src={techToMed} alt="TechToMed" />
                <h1>TechToMed</h1>
                  </div> */}
                  <div class="col-md-12">
                    <div class="logo-header d-print-flex flex-row justify-content-center ">
                      <div class="print-logo text-center ">
                        <img src={practice_logo} class="print-practice-logo" alt="TechToMed" />
                      </div>
                      {/* <div class="practice-details ml-auto">
                        <p>Company Name</p>
                        <p>Company Address</p>
                      </div> */}
                    </div>
                  </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h4>Payment Details</h4>
                </div>
              </div>
              {this.props.loadingTransaction ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} alt="loader" className={style.loading} />
                </div>
              ) : (
                <div className="row">
                  {/* 


                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Transaction Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.payment &&
                            paymentDetails.payment.transaction_id}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payment Date:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.payment &&
                            moment(paymentDetails.payment.created_at).format(
                              "YYYY-MM-DD"
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payer_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payee_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Bank Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payer_bank_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Bank Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payee_bank_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Account Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payer_account_number}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Account Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payee_account_number}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Amount (ZAR):</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            paymentDetails.paymentDetail.payment_amount}
                        </p>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-lg-12">
                    <table
                      className={`table table-borderless ${style.paymentDetailsTable}`}
                    >
                      <tbody>
                        <tr>
                          <td width="50%">
                            <table>
                              <tr>
                                <td width="50%">
                                  <p>Transaction Number: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.payment &&
                                    paymentDetails.payment.transaction_id
                                      ? paymentDetails.payment.transaction_id
                                      : "Not Provided"}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width="50%">
                                  <p>Payer Name: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                    paymentDetails.paymentDetail.payer_name
                                      ? paymentDetails.paymentDetail.payer_name
                                      : "Not Provided"}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width="50%">
                                  <p>Payer Bank Name: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    <p>
                                      {paymentDetails.paymentDetail &&
                                      paymentDetails.paymentDetail
                                        .payer_bank_name
                                        ? paymentDetails.paymentDetail
                                            .payer_bank_name
                                        : "Not Provided"}
                                    </p>
                                  </p>
                                </td>
                              </tr>

                              <tr>
                                <td width="50%">
                                  <p>Payer Account Number: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                    paymentDetails.paymentDetail
                                      .payer_account_number
                                      ? paymentDetails.paymentDetail
                                          .payer_account_number
                                      : "Not Provided"}
                                  </p>
                                </td>
                              </tr>

                              <tr>
                                <td width="50%">
                                  <p>Amount (ZAR): </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                    paymentDetails.paymentDetail.payment_amount
                                      ? formatNumberToCurrency(paymentDetails.paymentDetail
                                          .payment_amount)
                                      : "Not Provided"}
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td width="50%">
                            <table>
                              <tr>
                                <td width="50%">
                                  <p>Payment Date: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.payment &&
                                    moment(
                                      paymentDetails.payment.created_at
                                    ).format("YYYY-MM-DD")
                                      ? moment(
                                          paymentDetails.payment.created_at
                                        ).format("YYYY-MM-DD")
                                      : "Not Provided"}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td width="50%">
                                  <p>Payee Name: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                      paymentDetails.paymentDetail.payee_name}
                                  </p>
                                </td>
                              </tr>

                              <tr>
                                <td width="50%">
                                  <p>Payee Bank Name: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                      paymentDetails.paymentDetail
                                        .payee_bank_name}
                                  </p>
                                </td>
                              </tr>

                              <tr>
                                <td width="50%">
                                  <p>Payee Account Number: </p>
                                </td>
                                <td width="50%">
                                  <p>
                                    {paymentDetails.paymentDetail &&
                                      paymentDetails.paymentDetail
                                        .payee_account_number}
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="row">
                <div class="logo-footer d-print-block d-none col-md-12">
                  <div class="print-logo text-center">
                    <p>Powered By:</p>
                    <img src={techToMed} class="print-ttm-logo" alt="TechToMed" />
                  </div>
                </div>
              </div>

            </div>
            
            <div className="row">
              <div className="col-md-12">
                {paymentProof && paymentProof.length !== 0 && (
                  <h4 className="mt-4">Proof of Payment</h4>
                )}

                {/* <p>
                  <i className="fa fa-file-pdf-o mr-2"></i>Payment-receipt-1.pdf
                </p> */}
                {paymentProof &&
                  paymentProof.map((element, index) => (
                    <a
                      key={element.attachment_id}
                      className={style.downloadLink}
                      onClick={(e) =>
                        this.DownloadAttachment(
                          element.attachment_id,
                          element.file_name
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o mr-2"></i>{" "}
                      {element.file_name}
                    </a>
                  ))}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.isLoading ? (
                  <div className={style.loadingWrapper}>
                    <img src={ttmLoader} className={style.loading} />
                  </div>
                ) : (
                  <div>
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div
                className={`col-lg-12 flex-column flex-md-row align-items-center ${style.paymentHistoryModalBtnWrapper}`}
              >
                <div className="mb-3 order-2 order-md-0">
                  <Button className="form-primary-btn" onClick={this.toggle}>
                    Cancel
                  </Button>
                </div>
                <div className="ml-md-auto mr-2 mb-3">
                  <input
                    type="text"
                    className={`form-control ${this.state.emailError ? "is-invalid" : ""}`}
                    id="patientEmail"
                    name="patientEmail"
                    placeholder="Enter email * "
                    value={this.state.patientEmail}
                    onChange={(e) => {
                      this.handleInputRef(e);
                    }}
                    // onBlur={() => handleNotesBlurChange()}
                  />
                  {this.state.emailError ? (
                    <span className="error">
                      Please Enter valid email address
                    </span>
                  ) : (
                    ""
                  )}
                  </div>
                  <div className="mb-3">
                  <Button
                    className="form-primary-btn mr-3"
                    onClick={this.shareViaEmail}
                  >
                    Share
                  </Button>

                  {/* <Button className="form-primary-btn">Print</Button> */}
                  <ReactToPrint
                    trigger={() => (
                      <Button className="form-primary-btn">Print</Button>
                    )}
                    content={() => this.componentRef}
                  />
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    historyListData: state.historyList,
    transactionData: state.transactionDetails,
    loadingTransaction: state.transactionDetails.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchHistoryList: (searchKey, sortBy, page, isScheduledPayment) =>
      dispatch(fetchHistoryList(searchKey, sortBy, page, isScheduledPayment)),
    fetchTransaction: (payment_id) => dispatch(fetchTransaction(payment_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistory);
